import { render, staticRenderFns } from "./Buzz.vue?vue&type=template&id=6d0cfb1c&scoped=true&"
import script from "./Buzz.vue?vue&type=script&lang=js&"
export * from "./Buzz.vue?vue&type=script&lang=js&"
import style0 from "./Buzz.vue?vue&type=style&index=0&id=6d0cfb1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0cfb1c",
  null
  
)

export default component.exports